import request from "@/utils/api_req.js";


/**
 * 邮箱验证码
 * @param data object
 */
export function emailCaptcha(data) {
    return request.post("login/email/captcha", data, {
        noAuth: true
    });
}

/**
 * 邮箱登录
 * @param data object 用户账号密码
 */
export function loginEmail(data) {
    return request.post("login/email", data, {
        noAuth: true
    });
}

/**
 * 获取用户信息
 *
 */
export function getUserInfo() {
    return request.get('user/info');
}

/*
 * 退出登录
 * */
export function getLogout() {
    return request.get("login/logout");
}

/*
 * 退出登录
 * */
export function getUpdateLogout() {
    return request.get("login/updateLogout");
}

/**
 * 邮箱注册登录
 * @param data object
 */
export function registerEmail(data) {
    return request.post("login/register/email", data, {
        noAuth: true
    });
}

/**
 * 校验手机
 * @param data object
 */
export function checkPhone(params) {
    return request.get("login/check/phone", '', {
        noAuth: true
    }, params);
}

/**
 * 申请实体卡
 */
export function create(data) {
    return request.post('u/cards/v3/create', data)
}

/**
 * 是否申请实体卡
 * @returns {*}
 */
export function isCreate() {
    return request.get('u/cards/isCreate')
}

/**
 * 卡 卡背面信息
 * @returns {*}
 */
export function cardBackInfo() {
    return request.get('u/cards/v3/cardsNoInfo')
}


/**
 * 卡信息
 * @returns {*}
 */
export function cardNoInfo(id) {
    return request.get('u/cards/v2/cardsInfo/'+ id)
}

/**
 * 卡信息
 * @returns {*}
 */
export function cardTransactions(params, id) {
    return request.get('u/cards/v2/transferList/'+ id, '', {}, params);
}

